export const TAB_FINANCIAL_ENTITY_ABOUT = 'about'
export const TAB_FINANCIAL_ENTITY_INDICATOR = 'indicator'
